export const infoSensor = [
  {
    label: 'serialNumber',
    type: 'text',
    name: 'sn',
    validation: 'required'
  },
  {
    label: 'id',
    type: 'text',
    name: 'id',
    validation: 'required'
  },
  {
    label: 'name',
    type: 'text',
    name: 'name',
    validation: 'required'
  },
  {
    label: 'description',
    type: 'text',
    name: 'description',
    validation: 'required'
  },
  {
    label: 'maxUpperCase',
    type: 'number',
    name: 'max',
    validation: 'required'
  },
  {
    label: 'minUpperCase',
    type: 'number',
    name: 'min',
    validation: 'required'
  }
];
